export var headers = {
	"Project-Id-Version": "",
	"Report-Msgid-Bugs-To": "",
	"POT-Creation-Date": "",
	"PO-Revision-Date": "",
	"Last-Translator": "",
	Language: "en_US",
	"Language-Team": "",
	"Content-Type": "text/plain; charset=UTF-8",
	"Content-Transfer-Encoding": "8bit",
	"Plural-Forms": "nplurals=2; plural=n != 1;",
	"MIME-Version": "1.0"
};
export default {
	headers: headers
};
